import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=79dcb40d&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=79dcb40d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dcb40d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79dcb40d')) {
      api.createRecord('79dcb40d', component.options)
    } else {
      api.reload('79dcb40d', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=79dcb40d&scoped=true", function () {
      api.rerender('79dcb40d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attendance/detail.vue"
export default component.exports